import api from './api';

export interface EmailTemplate {
  _id?: string;
  name: string;
  subject: string;
  content: string;
  emailAccountId?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

class EmailTemplateService {
  // Tüm şablonları getir
  async getTemplates(): Promise<EmailTemplate[]> {
    try {
      const response = await api.get('/email-templates');
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error('❌ Error fetching email templates:', error);
      return [];
    }
  }

  // Yeni şablon oluştur
  async createTemplate(templateData: Omit<EmailTemplate, '_id'>): Promise<EmailTemplate | null> {
    try {
      const response = await api.post('/email-templates', templateData);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('❌ Error creating email template:', error);
      throw error;
    }
  }

  // Şablon güncelle
  async updateTemplate(id: string, templateData: Omit<EmailTemplate, '_id'>): Promise<EmailTemplate | null> {
    try {
      const response = await api.put(`/email-templates/${id}`, templateData);
      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error) {
      console.error('❌ Error updating email template:', error);
      throw error;
    }
  }

  // Şablon sil
  async deleteTemplate(id: string): Promise<boolean> {
    try {
      const response = await api.delete(`/email-templates/${id}`);
      return response.data.success;
    } catch (error) {
      console.error('❌ Error deleting email template:', error);
      return false;
    }
  }
}

const emailTemplateService = new EmailTemplateService();
export default emailTemplateService;
